<template>
  <generic-container
    :title="$t('sociocultural representation')"
    icon="quidditch"
    :show_plus="true"
    :configurable="true"
    :searchable="true"
    @filter="filter"
    v-bind:configure_modal="configure_modal"
    @add="add"
    :header_buttons="header_buttons"
  >
    <div class="ui three horizontal link cards">
      <div
        class="card"
        v-for="(piece, index) in pieces"
        :key="index"
        @click="show_piece(piece)"
      >
        <div class="image">
          <img :src="image_resource_url(piece.setup)" />
        </div>
        <div class="content">
          <!-- <pre>{{piece}}</pre> -->
          <div class="extra">ID: {{ piece.piece_id }}</div>
          <div class="header">{{ piece.setup.name }}</div>
          <div class="meta" v-if="piece.setup.site">
            {{ piece.setup.site }}
          </div>
          <div class="extra" v-if="piece.setup.origin">
            {{ piece.setup.origin }}
          </div>
          <div class="meta">{{ piece.setup.region }}</div>
          <div class="extra">{{ piece.setup.style }}</div>
          <div class="meta">{{ piece.setup.support }}</div>
          <div class="extra">
            {{ piece.setup.temporality }}
          </div>
          <!-- <div class="description">
            {{ piece.setup.description | truncate(75) }}
          </div> -->
        </div>
      </div>
    </div>
    <!-- <pre>{{ pieces }} </pre> -->
    <template v-for="(mdl, index) in piece_modals">
      <component
        :is="mdl"
        :key="index"
        :piece_in="selected_piece"
        @succedded="succedded"
        @destroy="destroy"
        @deleted="deleted"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import { local_api, error_toast, api_host } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./ArcheologyConfigureModal";
import ConfigureModal from "./configure_modal/Index";
import PieceModal from "./ArcheologyPieceModal";
import _ from "lodash";

// @ is an aliass to /src
export default {
  name: "ArcheologyIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      piece_modals: [],
      configure_modal: ConfigureModal,
      selected_piece: undefined,
      all_pieces: [],
      pieces: [],
      header_buttons: [
        {
          icon: "list",
          color: "blue",
          click: this.catalog,
          tooltip: this.$t("virtual catalog"),
        },
      ],
    };
  },
  methods: {
    add() {
      this.piece_modals.push(PieceModal);
    },
    succedded(piece) {
      if (piece.setup && typeof piece.setup == "string")
        piece.setup = JSON.parse(piece.setup);
      let trgtIndex = this.pieces.findIndex((p) => p.uuid == piece.uuid);
      if (trgtIndex >= 0) this.pieces.splice(trgtIndex, 1, piece);
      else this.pieces.push(piece);
      this.selected_piece = undefined;
    },
    destroy() {
      this.selected_piece = undefined;
      this.píece_modals = [];
    },
    image_resource_url(piece) {
      if (!piece.images || piece.images.length == 0)
        return `/images/icons/archeology.jpg`;
      else {
        let file_name = piece.images[0].server_file;
        return `${api_host}/public/uploads/archeology/${file_name}`;
      }
    },
    show_piece(piece) {
      this.selected_piece = piece;
      this.piece_modals.push(PieceModal);
    },
    filter(q) {
      if (!q) this.pieces = _.cloneDeep(this.all_pieces);
      else
        this.pieces = this.all_pieces.filter((p) =>
          p.setup.name.toUpperCase().includes(q.toUpperCase()),
        );
    },
    deleted(piece_uuid) {
      let vm = this;
      let idx = vm.pieces.findIndex((n) => n.uuid == piece_uuid);
      if (idx >= 0) vm.pieces.splice(idx, 1);
      // this.piece_modals = [];
    },
    catalog() {
      this.$router.push({
        name: "ArcheologyCatalog",
      });
    },
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/archeology/do-get-pieces")
      .then((r) => {
        vm.pieces = r.sort((a, b) => {
          if (a.piece_id > b.piece_id) return 1;
          if (a.piece_id < b.piece_id) return -1;
          return 0;
        });
        vm.all_pieces = _.cloneDeep(r);
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  mounted() {},
  watch: {},
};
</script>
